import React from "react";
import { Segment, Grid, Container, Header } from "semantic-ui-react";

const style = {
  footer : {
      padding: "3em 0em"
  }
};

const AppFooter = () => (
  <Segment inverted vertical color="pink" style={style.footer}>
    <Container>
      <Grid divided stackable centered>
        <Grid.Row>
          <Grid.Column width={5}>
            <Header as="h4" content="Contract" />
            <address style={{fontSize: '1.1em'}}>
              <a href="mailto:custombookinfo@gmail.com">custombookinfo@gmail.com</a>
            </address>
          </Grid.Column>
          <Grid.Column width={7}>
            <Header as="h4">
              About
            </Header>
            <p>
              CustomBook offers personalized children’s books that use animated pictures
              from family and friends to deliver quality and influential story’s to your
              child. This is a beta test website that is intended to help us streamline
              the bookmaking process with a full scale website coming soon.
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>
);

export default AppFooter;
